import classnames from "classnames/bind";
import styles from "../introduce.module.scss";

const cx = classnames.bind(styles);

const Company = () => {

	return (
		<div className={cx('contents')}>
			<div className={cx('titleWrap')}>
				<span className={cx('title')}>기업은<br />알고 있습니다</span>
			</div>
			<div className={cx('companyImgWrap')}>
				<img src={'/img/acc/introduce/imgCompany01.png'} alt={''} />
				<img src={'/img/acc/introduce/imgCompany02.png'} alt={''} />
			</div>
			<div className={cx('textWrap')}>
				<div className={cx('descTitleWrap')}>
					<span className={cx('descTitle')}>기업이 원하는 인재,<br />성과를 잘 내는 사람입니다.</span>
				</div>
				<div className={cx('descWrap')}>
					<span className={cx('desc')}>취업을 준비하면서 우리는 흔히들 기업이 원하는 인재는 스펙, 학력, 경력, 지식이 좋은 사람이라고 생각합니다. <em className={cx('bold')}>하지만, 기업이 원하는 인재는 자신에게 주어진 역할과 기회를 통해 성과를 잘 내고 잘 성장할 수 있는 ‘일을 잘하는 사람’입니다.</em></span>
					<span className={cx('desc')}>세계적인 기업인 <em className={cx('bold')}>구글의 인사책임자</em>는 말합니다. “학벌이나 자격증은 업무 능력과 전혀 상관이 없다. <em className={cx('bold')}>대학을 나오지 않은 사람들이 종종 ‘가장 높은 성과’를 냈다”</em> -뉴욕타임즈 인터뷰-</span>
					<span className={cx('desc')}>학력과 경력에 대한 오해가 있습니다. 학교에서 인재는 있는 정답을 잘 맞추는 사람이지만, 직장에서의 인재는 없는 답을 찾고 만들어가는 사람입니다.</span>
					<span className={cx('desc')}>기업이 원하는 인재는 <em className={cx('bold')}>일을 잘하는 사람, 잘 클 수 있는 사람, 그리고 우리 회사에 잘 맞는 사람입니다.</em> 이 3가지 조건의 공통점이 <em className={cx('bold')}>바로 역량입니다.</em></span>
				</div>
			</div>
		</div>

	)
};

export default Company;
